import { lang } from '../../assets/lang'
import { userInputFlowSingleSelectOptions } from '../../data'
import { getSelectOptionsFromArrayOfObjects } from '../../functions/utils'

const instagram_bot_addon = window.xitFlowBuilderData.instagram_addon

const facebookBotTextComponentFields =
'<span class="d-inline-block lead-user-name">' + 
'<a id="text-text-spintext-firstname" title="' + lang.text_html_info_firstname + '" data-toggle="tooltip" data-placement="top" class="btn-sm lead_first_name button-outline"><i class="fa fa-user"></i> ' + lang.text_html_title_first_name + '</a>' +
'</span>' + 
'<span class="d-inline-block lead-user-name">' + 
'<a id="text-text-spintext-lastname" title="' + lang.text_html_info_lastname + '" data-toggle="tooltip" data-placement="top" class="btn-sm lead_last_name button-outline"><i class="fa fa-user"></i> ' + lang.text_html_title_last_name + '</a>' +
'</span>'

const instagramBotTextComponentFields =
'<span class="d-inline-block lead-user-name">' + 
'<a id="text-text-spintext-lastname" title="' + lang.text_html_instagram_username_info + '" data-toggle="tooltip" data-placement="top" class="btn-sm lead_last_name button-outline"><i class="fa fa-user"></i> ' + lang.text_html_instagram_username + ' </a>' +
'</span>'

let commonFields = ! instagram_bot_addon 
  ? facebookBotTextComponentFields
  : instagramBotTextComponentFields

export const userInputFlowSingleHtml = '' +
'<div class="form-group text-left mt-3 pb-4">' +
  '<div class="control-label pb-2">' + lang.user_input_flow_single_html_question_type + '</div>' +
  '<div class="custom-switches-stacked mt-2">' +
    '<label class="custom-switch pb-1">' +
      '<input type="radio" name="question-type" value="keyboard" class="custom-switch-input">' +
      '<span class="custom-switch-indicator"></span>' +
      '<span class="custom-switch-description">' + lang.user_input_flow_single_html_question_type_keyboard + '</span>' +
    '</label>' +

    '<label class="custom-switch">' +
      '<input type="radio" name="question-type" value="multiple" class="custom-switch-input">' +
      '<span class="custom-switch-indicator"></span>' +
      '<span class="custom-switch-description">' + lang.user_input_flow_single_html_question_type_multiple + '</span>' +
    '</label>' +
  '</div>' +
'</div>' +

'<div class="text-left d-none" id="question-fields">' +
  '<div class="form-group pb-3" id="question-fields-keyboard">' +
    '<label>' + lang.user_input_flow_single_html_question + '</label><br/>' +
    '<div class="d-inline-block lead-user-name question-custom-variable">' + 
      '<a title="' + lang.text_html_info_custom_variable + '" data-toggle="dropdown" data-toggle-second="tooltip" data-placement="top" role="button" aria-haspopup="true" aria-expanded="false" class="btn btn-link btn-sm p-0 p-1 dropdown-toggle"><i class="fa fa-cogs"></i> ' + lang.text_html_title_custom + '</a>' +
      '<div class="dropdown-menu" data-animation="fadeIn"></div>' +
    '</div>' + 
    
    commonFields + 

    '<div class="clearfix"></div><textarea class="form-control text_message"  name="question-answer" id="question-answer" placeholder="' + lang.user_input_flow_single_html_question_placeholder + '"></textarea>' +
  '</div>' +  

  '<div class="text-left d-none" id="question-fields-multiple">' + 
    '<div class="form-group row pl-3 pr-3" id="choices-list">' +
      '<div class="col-6 p-1">' +
        '<input type="text" class="form-control multiple-choice" placeholder="' + lang.user_input_flow_single_html_question_option1_placeholder + '">' +
      '</div>' +

      '<div class="col-6 p-1">' +
        '<input type="text" class="form-control multiple-choice" placeholder="' + lang.user_input_flow_single_html_question_option2_placeholder + '">' +
      '</div>' +
    '</div>' +

    '<div class="form-group pt-2 pb-3 text-center">' +
      '<button type="button" class="btn btn-sm btn-outline-primary" id="add-more-choice"><i class="fas fa-plus-circle"></i> ' + lang.user_input_flow_single_html_question_option_add_more + '</button>' +
    '</div>' +
  '</div>' +    

  '<div class="form-group pb-3">' +
    '<label class="pb-1">' + lang.user_input_flow_single_html_reply_type + '</label>' +
    '<select name="reply-type" class="form-control select2" id="reply-type">' +
      getSelectOptionsFromArrayOfObjects(userInputFlowSingleSelectOptions) +
    '</select>' +
  '</div>' +

  '<div class="form-group pb-3 d-none" id="email-quickreply-wrapper">' +
    '<div class="custom-control custom-checkbox">' +
      '<input type="checkbox" id="email-quickreply" name="email-quickreply" class="custom-control-input">' +
      '<label class="custom-control-label" for="email-quickreply">' + lang.user_input_flow_single_html_quick_reply_email + '</label>' +
    '</div>' +
  '</div>' +

  '<div class="form-group pb-3 d-none" id="phone-quickreply-wrapper">' +
    '<div class="custom-control custom-checkbox">' +
      '<input type="checkbox" id="phone-quickreply" name="phone-quickreply" class="custom-control-input">' +
      '<label class="custom-control-label" for="phone-quickreply">' + lang.user_input_flow_single_html_quick_reply_phone + '</label>' +
    '</div>' +
  '</div>' +

  '<div class="form-group pb-3">' +
    '<div class="d-flex justify-content-between">' +
      '<label class="pb-1">' + lang.user_input_flow_single_html_custom_field + '</label>' +
      '<span class="text-small text-primary add-custom-custom-field" id="add-custom-custom-field"><i class="fas fa-plus-circle"></i> ' + lang.user_input_flow_single_html_assign_to_labels_create_new + '</span>' +
    '</div>' +  
    '<select name="custom-field" class="form-control select2" id="custom-field"></select>' +
  '</div>' +

  '<div class="subtype-creator-wrapper d-none" id="subtype-creator-wrapper">' +
    '<span class="subtype-creator-close"><i class="fa fa-times"></i></span>' +
    '<p class="m-0 pt-3 pb-2 pl-0 text-small text-danger d-none" id="custom-field-error-message">Please fill in all the fields</p>' +
    '<div class="form-group pb-3">' +
      '<label class="pb-1">Custom field name</label>' +
      '<input type="text" class="form-control" name="custom-field-name" id="custom-field-name">' +
    '</div>' +

    '<div class="form-group pb-3">' +
      '<label class="pb-1">' + lang.user_input_flow_single_html_reply_type + '</label>' +
      '<select name="custom-field-reply-type" class="form-control select2" id="custom-field-reply-type">' +
        getSelectOptionsFromArrayOfObjects(userInputFlowSingleSelectOptions) +
      '</select>' +
    '</div>' +

    '<div class="form-group text-center">' + 
      '<button type="button" class="btn btn-primary btn-sm" id="save-custom-field">Save</button>' + 
    '</div>' +
  '</div>' +

  '<div class="form-group pb-3" id="system-field-wrapper">' +
    '<label class="pb-1">' + lang.user_input_flow_single_html_system_field + '</label>' +
    '<select name="system-field" class="form-control select2" id="system-field">' +
      '<option value="">' + lang.user_input_flow_single_html_system_field_select + '</option>' +
      '<option value="email">' + lang.user_input_flow_single_html_system_field_email + '</option>' +
      '<option value="phone">' + lang.user_input_flow_single_html_system_field_phone + '</option>' +
      '<option value="birthday">' + lang.user_input_flow_single_html_system_field_birthday + '</option>' +
      '<option value="location">' + lang.user_input_flow_single_html_system_field_location + '</option>' +
    '</select>' +
  '</div>' +

  '<div class="form-group pb-3" id="assign-to-labels-wrapper">' +
    '<div class="d-flex justify-content-between">' +
      '<label class="pb-1">' + lang.user_input_flow_single_html_assign_to_labels + '</label>' +
      '<span class="text-small text-primary text-underline" data-toggle="tooltip" data-original-title="' + lang.user_input_flow_single_html_assign_to_labels_create_new_info + '"><i class="fas fa-plus-circle"></i> ' + lang.user_input_flow_single_html_assign_to_labels_create_new + '</span>' +
    '</div>' +     

    '<select name="assign-to-labels" class="form-control select2" id="assign-to-labels" multiple></select>' +
  '</div>' +

  '<div class="form-group pb-3" id="assign-to-messenger-sequence-wrapper">' +
    '<label class="pb-1">' + lang.user_input_flow_single_html_assign_to_messenger_sequence + '</label>' +
    '<select name="assign-to-messenger-sequence" class="form-control select2" id="assign-to-messenger-sequence"></select>' +
  '</div>' +

  '<div class="form-group pb-3" id="assign-to-email-phone-sequence-wrapper">' +
    '<label class="pb-1">' + lang.user_input_flow_single_html_assign_to_email_phone_sequence + '</label>' +
    '<select name="assign-to-email-phone-sequence" class="form-control select2" id="assign-to-email-phone-sequence"></select>' +
  '</div>' +

  '<div class="form-group pb-3" id="skip-button-field-wrapper">' +
    '<label class="pb-1">' + lang.user_input_flow_single_html_skip_button_text + '</label>' +
    '<input type="text" class="form-control" name="skip-button-field" id="skip-button-field" placeholder="Put your skip button text here">' +
  '</div>' +
'</div>'
